export default {
  // Hero
  'home.greeting.morning': 'Good morning, {name}',
  'home.greeting.afternoon': 'Good afternoon, {name}',
  'home.greeting.evening': 'Good evening, {name}',
  'home.greeting.fallback': 'Hello',
  'home.greeting.morning.salute': 'Good morning',
  'home.greeting.afternoon.salute': 'Good afternoon',
  'home.greeting.evening.salute': 'Good evening',
  'home.eyebrow.today': 'Today is {date}',
  'home.summary.tasks': 'You have {count} pending tasks',
  'home.summary.tasks.zero': 'No pending tasks — you are all caught up',
  'home.summary.requests': '{count} requests this month',
  'home.summary.requests.zero': 'No requests yet this month',
  'home.summary.requests.prev': '{count} requests in the selected month',
  'home.summary.requests.prev.zero': 'No requests in the selected month',
  'home.summary.requests.year': '{count} requests this year',
  'home.summary.requests.year.zero': 'No requests yet this year',
  'home.summary.requests.customYear': '{count} requests in {year}',
  'home.summary.requests.customYear.zero': 'No requests in {year}',
  'home.period.month': 'This month',
  'home.period.previous': 'Previous month',
  'home.period.year': 'This year',
  'home.period.custom': 'Pick month',
  'home.period.custom.aria': 'Select month and year',
  'home.period.wholeYear': 'Whole year {year}',
  'home.period.prevYear': 'Previous year',
  'home.period.nextYear': 'Next year',
  'home.period.aria': 'Period selector',

  // KPI strip
  'home.kpi.requests': 'Requests',
  'home.kpi.requests.prev': 'Requests (previous month)',
  'home.kpi.requests.year': 'Requests this year',
  'home.kpi.requests.custom': 'Requests in {month}',
  'home.kpi.requests.customYear': 'Requests in {year}',
  'home.kpi.aria': 'Key request metrics for the period',
  'home.kpi.pending': 'Pending',
  'home.kpi.approved': 'Approved',
  'home.kpi.problems': 'Rejected',
  'home.kpi.delta.up': '+{value}% vs previous month',
  'home.kpi.delta.down': '{value}% vs previous month',
  'home.kpi.delta.flat': 'No change vs previous month',
  'home.kpi.viewBreakdown': 'View full breakdown',

  // Quick launch
  'home.quickLaunch.title': 'Quick launch',
  'home.quickLaunch.subtitle': 'Your favorite processes, one click away',
  'home.quickLaunch.empty':
    "You don't have favorites yet. Star your processes in /processes to launch them quickly from here.",
  'home.quickLaunch.empty.cta': 'Go to processes',
  'home.quickLaunch.start': 'Start',
  'home.quickLaunch.viewAll': 'View all',

  // System health (admin)
  'home.systemHealth.title': 'System health',
  'home.systemHealth.processes': 'Active processes',
  'home.systemHealth.users': 'Active users',
  'home.systemHealth.entities': 'Active entities',
  'home.systemHealth.documents': 'Generated documents',

  // Plan limits (admin)
  'home.planLimits.title': 'Plan & usage',
  'home.planLimits.subtitle': 'Current usage against your plan limits',
  'home.planLimits.requests': 'Requests',
  'home.planLimits.aiCredit': 'AI credit',
  'home.planLimits.storage': 'Storage',
  'home.planLimits.emails': 'Emails sent',
  'home.planLimits.documents': 'Documents',
  'home.planLimits.warn': 'Near the limit',
  'home.planLimits.over': 'Over plan',
  'home.planLimits.cta': 'View plan details',
  'home.planLimits.cta.soon': 'Coming soon',
  'home.planLimits.usage': '{used} of {total}',
  'home.planLimits.unlimited': 'Unlimited',

  // AI consumption (admin)
  'home.ai.title': 'AI consumption',
  'home.ai.subtitle': 'Tokens consumed this period',
  'home.ai.empty': 'No AI consumption in this period.',
  'home.ai.viewAll': 'View all consumption',
  'home.ai.total': 'Total',
  'home.ai.creditOf': 'of {total}',

  // My activity (user)
  'home.myActivity.title': 'My activity',
  'home.myActivity.subtitle': 'Distribution of my requests this period',
  'home.myActivity.empty': 'No activity in this period yet.',
  'home.myActivity.viewBreakdown': 'View all 8 statuses',

  // Pending tasks
  'home.tasks.title': 'Pending tasks',
  'home.tasks.empty': 'No pending tasks. Great work!',
  'home.tasks.viewAll': 'Go to tasks',
  'home.tasks.count': '{count} tasks',
  'home.tasks.count.one': '1 task',

  // Last requests
  'home.lastRequests.title': 'Latest requests',
  'home.lastRequests.subtitle': 'The most recent ones in this period',
  'home.lastRequests.empty': 'No requests have been sent in this period yet.',
  'home.lastRequests.viewAll': 'View all',

  // Most used
  'home.mostUsed.title': 'Most used processes',
  'home.mostUsed.subtitle': 'Processes with the highest activity this period',
  'home.mostUsed.empty': 'No process activity in this period.',
  'home.mostUsed.start': 'Start',
  'home.mostUsed.viewAll': 'View all',
  'home.mostUsed.usage': '{count} requests',
  'home.mostUsed.usage.one': '1 request',

  // Partners
  'home.partners.title': 'Top collaborators',
  'home.partners.subtitle': 'Top 5 with the most activity this period',
  'home.partners.toggleShow': 'Show',
  'home.partners.toggleHide': 'Hide',
  'home.partners.empty': 'No external collaborators in this period.',

  // Status breakdown
  'home.breakdown.title': 'Full status breakdown',
  'home.breakdown.subtitle': 'Distribution of requests in {period}',
  'home.breakdown.close': 'Close',
  'home.breakdown.total': 'Total: {count}',

  // Status labels
  'home.status.total': 'Total',
  'home.status.sent': 'Sent',
  'home.status.received': 'Received',
  'home.status.pending': 'Pending',
  'home.status.approved': 'Approved',
  'home.status.rejected': 'Rejected',
  'home.status.error': 'Errored',
  'home.status.canceled': 'Canceled',
  'home.status.voided': 'Voided',

  // Errors
  'home.error.title': "We couldn't load this section",
  'home.error.retry': 'Retry',
};
